import React from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from 'layout/atoms/Accordion/Accordion';
import Card from 'layout/atoms/Card/Card';
import ParameterDetails from 'layout/atoms/ParameterDetails/ParameterDetails';
import Grid from '../Grid/Grid';
import styles from './ComponentVariantCard.module.scss';
function ComponentVariantCard({ component }) {
    const { t } = useTranslation(['specification', 'common']);
    const componentHeader = (component) => {
        return (React.createElement("div", { className: styles.wrap },
            React.createElement("p", null, component.name),
            component.productCategory.variantHasColor && (React.createElement("p", null, component.hasOneVariantColorForAllSpecificationColors
                ? component.variantColorForAllSpecificationColors
                : t('consumptionVariedOnColorTrue'))),
            component.productCategory.variantHasSize && (React.createElement("p", null, component.hasOneVariantSizeForAllSpecificationSizes
                ? component.variantSizeForAllSpecificationSizes
                : t('consumptionVariedOnSizeTrue')))));
    };
    return (React.createElement(Card, { size: "xs", bgColor: "white" }, !component.hasOneVariantColorForAllSpecificationColors ||
        !component.hasOneVariantSizeForAllSpecificationSizes ? (React.createElement(Accordion, { key: component.id, header: componentHeader(component) },
        React.createElement("div", { className: styles.details },
            React.createElement(Grid, { columns: 2 },
                React.createElement(Grid, null, component.colors.edges.map((color) => {
                    var _a;
                    return (React.createElement(ParameterDetails, { key: color.node.modelSpecificationColor.name, label: color.node.modelSpecificationColor.name, value: ((_a = color.node) === null || _a === void 0 ? void 0 : _a.productVariantColor) || '-' }));
                })),
                React.createElement(Grid, null, component.productCategory.variantHasSize &&
                    !component.hasOneVariantSizeForAllSpecificationSizes &&
                    component.sizes.edges.map((size) => (React.createElement(ParameterDetails, { key: size.node.modelSpecificationSize.sizeName.name, label: size.node.modelSpecificationSize.sizeName.name, value: size.node.productVariantSize || '-' })))))))) : (componentHeader(component))));
}
export default ComponentVariantCard;
